export function IlustracaoVagaCriada(props) {
  return (
    <svg
      width={264}
      height={173}
      viewBox="0 0 264 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M247.468 162.833s26.845-17.508 10.761-33.883c-16.081-16.374-20.892-14.346-16.262-32.597 4.629-18.25 23.381-25.04 15.925-38.89-8.949-16.623-29.352-1.458-42.034 4.364-23.577 10.822-23.436-5.356-14.381-20.492C210.531 26.2 211.181.964 190.27.964 167.526.964 117.542 50.2 90.005 84.23c-16.48 20.366-28.49 6.195-26.822-6.89 1.06-8.316 3.267-21.758-1.897-27.943-8.964-10.735-35.295 22.899-44.592 37.268-36.386 56.241 7.843 76.168 7.843 76.168h222.931zM44.51 25.808c1.021-2.346 1.348-4.145.623-5.628-2.148-4.394-13.098-5.099-20.112-.822-9.78 5.962-12.366 21.891-7.889 25.428 5.21 4.115 22.112-6.864 27.379-18.978z"
        fill="#FFE4CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.538 167.539h82.629v-.471h-82.629v.471zM176.979 172.245h36.15v-.471h-36.15v.471zM99.984 172.245h65.728v-.471H99.984v.471zM50.688 172.245h9.86v-.471h-9.86v.471zM63.364 172.245h2.817v-.471h-2.817v.471zM207.025 168.01h16.902v-.471h-16.902v.471zM82.144 167.539h25.821v-.471H82.144v.471zM32.379 167.539h44.6v-.471h-44.6v.471zM18.764 167.539h7.98v-.471h-7.98v.471zM78.857 162.833H185.43v-137.4H78.857v137.4z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.96 157.187h94.836V31.079H84.961v126.108z"
        fill="#fff"
      />
      <path
        opacity={0.1}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.96 156.64h94.836V30.532H84.961V156.64z"
        fill="#FFE4CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M161.147 65.9l-6.704-5.599 1.834-2.25 4.44 3.708 9.311-11.858 2.256 1.815L161.147 65.9z"
        fill="#FF7A5C"
      />
      <mask id="prefix__a" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M138.951 58.842h8.92v-.47h-8.92v.47z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.951 58.842h8.92v-.47h-8.92v.47z"
        fill="#F7902A"
      />
      <path
        d="M138.951 58.842h-1v1h1v-1zm8.92 0v1h1v-1h-1zm0-.47h1v-1h-1v1zm-8.92 0v-1h-1v1h1zm0 1.47h8.92v-2h-8.92v2zm9.92-1v-.47h-2v.47h2zm-1-1.47h-8.92v2h8.92v-2zm-9.92 1v.47h2v-.47h-2z"
        fill="#F7B500"
        mask="url(#prefix__a)"
      />
      <mask id="prefix__b" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.373 58.842h26.291v-.47h-26.291v.47z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.373 58.842h26.291v-.47h-26.291v.47z"
        fill="#F7902A"
      />
      <path
        d="M109.373 58.842h-1v1h1v-1zm26.291 0v1h1v-1h-1zm0-.47h1v-1h-1v1zm-26.291 0v-1h-1v1h1zm0 1.47h26.291v-2h-26.291v2zm27.291-1v-.47h-2v.47h2zm-1-1.47h-26.291v2h26.291v-2zm-27.291 1v.47h2v-.47h-2z"
        fill="#F7B500"
        mask="url(#prefix__b)"
      />
      <mask id="prefix__c" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M126.744 63.077h21.127v-.47h-21.127v.47z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.744 63.077h21.127v-.47h-21.127v.47z"
        fill="#F7902A"
      />
      <path
        d="M126.744 63.077h-1v1h1v-1zm21.127 0v1h1v-1h-1zm0-.47h1v-1h-1v1zm-21.127 0v-1h-1v1h1zm0 1.47h21.127v-2h-21.127v2zm22.127-1v-.47h-2v.47h2zm-1-1.47h-21.127v2h21.127v-2zm-22.127 1v.47h2v-.47h-2z"
        fill="#F7B500"
        mask="url(#prefix__c)"
      />
      <mask id="prefix__d" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M124.396 63.077h.939v-.47h-.939v.47z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.396 63.077h.939v-.47h-.939v.47z"
        fill="#F7902A"
      />
      <path
        d="M124.396 63.077h-1v1h1v-1zm.939 0v1h1v-1h-1zm0-.47h1v-1h-1v1zm-.939 0v-1h-1v1h1zm0 1.47h.939v-2h-.939v2zm1.939-1v-.47h-2v.47h2zm-1-1.47h-.939v2h.939v-2zm-1.939 1v.47h2v-.47h-2z"
        fill="#F7B500"
        mask="url(#prefix__d)"
      />
      <mask id="prefix__e" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.637 63.077h23.943v-.47H97.637v.47z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.637 63.077h23.943v-.47H97.637v.47z"
        fill="#F7902A"
      />
      <path
        d="M97.637 63.077h-1v1h1v-1zm23.943 0v1h1v-1h-1zm0-.47h1v-1h-1v1zm-23.943 0v-1h-1v1h1zm0 1.47h23.943v-2H97.637v2zm24.943-1v-.47h-2v.47h2zm-1-1.47H97.637v2h23.943v-2zm-24.943 1v.47h2v-.47h-2z"
        fill="#F7B500"
        mask="url(#prefix__e)"
      />
      <mask id="prefix__f" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.637 67.312h34.272v-.471H97.637v.47z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.637 67.312h34.272v-.471H97.637v.47z"
        fill="#F7902A"
      />
      <path
        d="M97.637 67.312h-1v1h1v-1zm34.272 0v1h1v-1h-1zm0-.471h1v-1h-1v1zm-34.272 0v-1h-1v1h1zm0 1.47h34.272v-2H97.637v2zm35.272-1v-.47h-2v.47h2zm-1-1.47H97.637v2h34.272v-2zm-35.272 1v.47h2v-.47h-2z"
        fill="#F7B500"
        mask="url(#prefix__f)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M161.147 88.016l-6.704-5.599 1.834-2.25 4.44 3.708 9.311-11.858 2.256 1.815-11.137 14.184z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.373 80.958h38.497v-.471h-38.497v.47zM97.637 80.958h8.92v-.471h-8.92v.47zM97.637 85.193h46.478v-.471H97.637v.47zM97.637 89.428h15.023v-.471H97.637v.47z"
        fill="#F7B500"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M161.147 110.132l-6.704-5.599 1.834-2.25 4.44 3.708 9.311-11.858 2.256 1.815-11.137 14.184z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.637 103.074h50.234v-.471H97.637v.471zM131.908 107.779h15.963v-.471h-15.963v.471zM97.637 107.779h30.985v-.471H97.637v.471zM97.637 111.544h43.192v-.471H97.637v.471z"
        fill="#F7B500"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.669 67.311h-1.878v-3.294l1.878 3.294z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.669 67.311h-1.878v-3.294h.505v2.732h1.373v.562zM168.997 67.311h-8.92v-.579h8.321v-8.831h.599v9.41z"
        fill="#F7B500"
      />
      <mask id="prefix__g" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M163.833 55.548h.939v-.47h-.939v.47z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M163.833 55.548h.939v-.47h-.939v.47z"
        fill="#7760DB"
      />
      <path
        d="M163.833 55.548h-1v1h1v-1zm.939 0v1h1v-1h-1zm0-.47h1v-1h-1v1zm-.939 0v-1h-1v1h1zm0 1.47h.939v-2h-.939v2zm1.939-1v-.47h-2v.47h2zm-1-1.47h-.939v2h.939v-2zm-1.939 1v.47h2v-.47h-2z"
        fill="#F7B500"
        mask="url(#prefix__g)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.791 56.489v-.941h6.103l-6.103.94z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.397 56.489h-.606v-1.412h6.573v.512h-5.967v.9zM162.425 89.427h-5.634v-1.411h.599v.89h5.035v.521zM168.998 89.898h-5.634v-.61h5.056V82.37h.578v7.529zM168.528 80.957h.47v-.94h-.47v.94zM157.378 87.075h-.587v-9.411h8.451v.574h-7.864v8.837zM168.997 112.014h-12.206v-5.647h.581v5.064h11.044v-2.028h.581v2.611zM168.528 109.191h.47v-.941h-.47v.941zM168.528 106.838h.47v-4.235h-.47v4.235zM163.833 100.25h.939v-.47h-.939v.47zM157.351 101.662h-.56v-2.353h5.634v.588h-5.074v1.765zM156.791 130.836h.469v-.941h-.469v.941zM168.997 134.13h-12.206v-2.353h.581v1.745h11.044v-1.504h.581v2.112zM168.528 130.836h.47v-6.588h-.47v6.588z"
        fill="#F7B500"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M161.147 132.718l-6.704-5.599 1.834-2.249 4.44 3.707 9.311-11.858 2.256 1.815-11.137 14.184z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.637 125.66h46.478v-.471H97.637v.471zM111.251 129.895h36.619v-.471h-36.619v.471zM107.496 129.895h.939v-.471h-.939v.471zM97.637 129.895h6.572v-.471h-6.572v.471zM97.637 134.13h17.84v-.471h-17.84v.471z"
        fill="#F7B500"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.088 25.433V40.02H158.2V25.433h-15.998l-4.114-8.94h-11.885l-4.114 8.94h-16.001z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.454 163.775H256.79v-.471H.454v.471z"
        fill="#FF7A5C"
      />
      <path
        opacity={0.4}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M199.557 67.67c-.849 3.955-2.272 7.764-3.407 11.646-1.17 3.996-2.349 8.061-2.335 12.227.019 5.418 2.157 10.8 5.856 14.74 1.449 1.543 3.142 2.892 4.258 4.695 1.116 1.801 1.528 4.276.281 5.989-1.798 2.472-5.646 1.936-8.277 3.481-3.312 1.944-3.772 6.899-1.884 10.255 1.889 3.356 10.487 12.959 22.756 10.581 5.491-1.064 12.934-6.319 12.722-11.939-.221-5.851-5.778-10.591-5.589-16.443.124-3.835 2.688-7.075 4.906-10.195 2.219-3.12 4.287-6.923 3.265-10.619-1.504-5.44-8.472-7.121-11.846-11.635-2.173-2.907-2.652-6.73-2.786-10.364-.136-3.634-.043-7.359-1.249-10.787-2.923-8.316-13.304-7.324-16.671 8.367z"
        fill="#1DB37C"
      />
      <path
        opacity={0.5}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.19 152.01h.47V88.957h-.47v63.053z"
        fill="#B3472E"
      />
      <path
        opacity={0.5}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.763 106.838l-.573-.094c.94-5.654 7.431-9.17 7.707-9.317l.275.507c-.065.034-6.516 3.531-7.409 8.904zM212.108 131.777c-.611-3.938-5.038-6.51-5.083-6.536l.265-.522c.192.109 4.714 2.733 5.369 6.962l-.551.096z"
        fill="#B3472E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.727 162.833h-6.604c-4.011 0-7.262-3.208-7.262-7.167v-6.008h21.127v6.008c0 3.959-3.251 7.167-7.261 7.167z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M201.861 152.482h21.127v-.471h-21.127v.471zM134.726 21.903a2.585 2.585 0 01-2.582 2.588 2.585 2.585 0 01-2.582-2.588 2.585 2.585 0 012.582-2.588 2.585 2.585 0 012.582 2.588z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.923 126.131h-.602v-4.235h7.512v.546h-6.91v3.689z"
        fill="#F7B500"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.19 8.728a4.787 4.787 0 012.803 2.81 4.787 4.787 0 012.804-2.81 4.79 4.79 0 01-2.804-2.81 4.789 4.789 0 01-2.804 2.81zm3.1 4.47h-.594c0-2.3-1.867-4.172-4.163-4.172V8.43a4.172 4.172 0 004.163-4.172h.595c0 2.3 1.867 4.172 4.162 4.172v.596a4.172 4.172 0 00-4.162 4.172z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.088 40.49h.469V25.433h-.469V40.49z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.06 49.986l3.323-.555 4.188 16.944-5.604.937-1.907-17.326z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.932 44.254l1.071 4.253-.12.03 1.06 4.205-.121.03 1.059 4.205-76.863 19.745-1.07-4.252.119-.03-1.059-4.205.12-.03L14.069 64l76.863-19.746zM10.783 77.953L4.56 79.546 1.394 67.022l6.223-1.593 3.166 12.524z"
        fill="#FFD169"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.886 76.07l-6.224 1.594L7.496 65.14l6.223-1.593 3.167 12.524zM112.191 45.576l-21.127-1.322 3.192 12.705 17.935-11.383z"
        fill="#FFE4CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.19 45.666l-6.205 4.235-.368-1.575 6.573-2.66zM112.19 45.637l-6.755 2.382-.756-2.823 7.511.44z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.825 52.724l-2.231-8.328.585-.142 2.232 8.329-.586.141z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6 81.202c.918-1.234 1.837-2.438 1.87-4.248.084-4.461-1.914-4.67-1.65-9.127.262-4.457 3.588-4.22 3.852-8.678a5.488 5.488 0 00-.112-1.534 11.23 11.23 0 01-.964-2.21 11.369 11.369 0 01-.525-3.65c.119-6.337 5.385-11.38 11.76-11.263 6.38.118 11.454 5.352 11.336 11.689a11.372 11.372 0 01-.66 3.63l-.123.331-.004.003a11.4 11.4 0 01-.923 1.843c-.115.449-.178.95-.166 1.523.097 4.464 3.426 4.35 3.523 8.814.096 4.464-1.908 4.599-1.991 9.06-.034 1.81.839 3.047 1.714 4.314.87 1.27 1.74 2.571 1.705 4.497-.103 5.526-4.692 9.92-10.252 9.817l-10.387-.191c-5.56-.103-9.978-4.663-9.875-10.189.036-1.925.956-3.193 1.872-4.43z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.002 90.149c.25 3.76-2.587 7.011-6.338 7.262-3.751.252-6.995-2.593-7.246-6.352-.25-3.76 2.587-7.011 6.338-7.263 3.75-.251 6.995 2.593 7.246 6.353z"
        fill="#FFC7BD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.009 68.943a3.761 3.761 0 01-3.497 4.007 3.758 3.758 0 01-3.998-3.505 3.761 3.761 0 013.497-4.007 3.759 3.759 0 013.998 3.505z"
        fill="#FF95A9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.097 64.096a2.816 2.816 0 013.396 2.086 2.816 2.816 0 11-5.477 1.318 2.823 2.823 0 012.08-3.404z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.792 64.975l15.762-.957.67 5.459-15.51 3.01-.922-7.512z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.073 160.48a1.88 1.88 0 01-1.878 1.883 1.88 1.88 0 01-1.878-1.883 1.88 1.88 0 011.878-1.882 1.88 1.88 0 011.878 1.882zM54.914 160.48c0 1.04.84 1.883 1.878 1.883a1.88 1.88 0 001.878-1.883 1.88 1.88 0 00-1.878-1.882 1.88 1.88 0 00-1.878 1.882z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.052 69.148l.434 21.256-13.488.906-7.054-21.88c-.467-1.447.546-2.949 2.057-3.05l14.021-.942c2.15-.144 3.986 1.545 4.03 3.71z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.574 69.901a3.756 3.756 0 004.394 2.99 3.763 3.763 0 002.982-4.405 3.756 3.756 0 00-4.394-2.989 3.763 3.763 0 00-2.982 4.404z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.166 90.839H47.758l-.723.567a10.129 10.129 0 00-3.858 7.968v2.914c0 2.253 1.807 4.079 4.037 4.079h11.644c2.23 0 4.037-1.827 4.037-4.079v-3.99c0-2.588-.592-5.14-1.729-7.459z"
        fill="#775298"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.826 75.958a3.881 3.881 0 00-.33-1.325l.005-.001-3.255-7.32-6.74 3.16 3.255 7.32.003-.001c.622 1.397 2.033 2.326 3.613 2.217 2.041-.14 3.585-1.953 3.45-4.05zM40.057 72.23a3.75 3.75 0 005.21 1.032 3.77 3.77 0 001.03-5.222 3.75 3.75 0 00-5.21-1.032 3.77 3.77 0 00-1.03 5.222z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.97 66.84L29.092 77.497 32.4 81.9l13.123-9-4.554-6.058z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.914 102.368a3.994 3.994 0 003.99 3.999c2.205 0 3.991-1.79 3.991-3.999s-1.786-4-3.99-4a3.995 3.995 0 00-3.99 4zM43.177 102.368a3.994 3.994 0 003.99 3.999c2.204 0 3.99-1.79 3.99-3.999s-1.786-4-3.99-4a3.995 3.995 0 00-3.99 4z"
        fill="#775298"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.914 122.836a3.29 3.29 0 003.286 3.294 3.29 3.29 0 003.287-3.294 3.29 3.29 0 00-3.287-3.294 3.29 3.29 0 00-3.286 3.294z"
        fill="#F2BE70"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.914 102.133v20.928l6.447.246 1.534-20.87-7.98-.304zM48.468 66.37l6.446-.879-1.066-8.061-6.446.88 1.066 8.06z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.84 66.338a3.288 3.288 0 003.694 2.826 3.293 3.293 0 002.82-3.703 3.287 3.287 0 00-3.695-2.825 3.292 3.292 0 00-2.819 3.702zM47.277 56.004l1.533-.206-.412-3.074-1.533.207a1.55 1.55 0 00.412 3.073z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.812 45.666L45.994 47.13l1.876 14.064 6.719-.909c2.69-.364 4.517-2.937 3.99-5.619l-1.767-9z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.918 52.686l-.286.038-1.109-8.234 8.51-1.14a4.103 4.103 0 014.614 3.513l.022.161-.286.038a11.295 11.295 0 00-6.44 3.159 8.815 8.815 0 01-5.025 2.465z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.792 72.017l-.453-6.587-10.345.671 10.798 5.916zM61.487 123.555l-2.795 36.926-3.778-.143v-37.031l6.573.248zM44.584 95.024a1.41 1.41 0 01-1.357 1.46 1.41 1.41 0 01-1.457-1.36 1.41 1.41 0 112.815-.1z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.956 97.896a1.754 1.754 0 01-.627-.092v.002l-3.152-1.055.35-2.959 3.293-.128c1.061-.042 1.952.872 1.99 2.04.037 1.17-.793 2.15-1.854 2.192z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.16 82.297a2.828 2.828 0 00.616-3.944 2.813 2.813 0 00-3.936-.617 2.828 2.828 0 00-.615 3.944 2.813 2.813 0 003.935.617z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.623 81.618l13.74 14.397 2.222-1.845-11.763-16.036-4.199 3.484z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.267 94.133l2.44-2.076-9.968-13.923-4.116 3.5 11.644 12.499z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.16 101.191l-9.843 58.53 3.714.76 14.127-57.654-7.998-1.636z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.296 160.48h3.778v2.824h-5.293c-.448 0-.81-.392-.81-.875 0-.312.155-.602.406-.757l1.919-1.192z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.772 56.018c.14.89-.477 1.724-1.379 1.863a1.65 1.65 0 01-1.887-1.361l3.266-.502z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.914 116.719h.47v-1.882h-.47v1.882z"
        fill="#624AC9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.743 49.6a1.413 1.413 0 01.617-1.898 1.407 1.407 0 011.894.619 1.413 1.413 0 01-.618 1.897 1.407 1.407 0 01-1.893-.619z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.484 47.79c.208-.108.425-.175.643-.206v-.002l3.475-.504.865 2.837-3.128 1.639c-1.008.528-2.24.113-2.752-.926-.512-1.039-.11-2.31.897-2.837z"
        fill="#FEC1AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.89 120.954h21.615l1.39-18.78-19.722-.983-3.282 19.763z"
        fill="#775298"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.692 160.48h-3.778v2.824h5.293c.448 0 .81-.392.81-.875a.887.887 0 00-.406-.757l-1.919-1.192z"
        fill="#FF7A5C"
      />
    </svg>
  );
}
